export default function Footer() {
  const handleWhatsAppClick = () => {
    if (typeof window !== "undefined" && typeof (window as any).gtag_report_conversion === "function") {
      (window as any).gtag_report_conversion();
    }
    window.open(
      'https://wa.me/5512997213362?text=Ol%C3%A1%20Dr.%20Gabriel%2C%20vim%20pelo%20site%20e%20quero%20analisar%20meu%20caso%20de%20bloqueio%20judicial',
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/bbb32f62fa49874c503b49ff6a2b85c0/9c9337ccdb8d6027eb0c0b5c7b5cb907.png"
              alt="G | A Advocacia"
              className="h-24 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Escritório especializado em desbloqueio de contas judiciais, Direito Tributário e Execuções Fiscais. Atendimento personalizado para pessoas físicas e empresas.
            </p>
            <div className="flex items-center gap-2 text-amber-400">
              <i className="ri-award-line"></i>
              <span className="font-semibold text-sm">OAB/SP 433.002</span>
            </div>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-6">Áreas de Atuação</h3>
            <ul className="space-y-3 text-gray-400">
              {[
                "Desbloqueio de Conta Judicial",
                "Impenhorabilidade de Salário",
                "Execuções Fiscais",
                "Nulidade de CDA",
                "Prescrição de Débitos Fiscais",
                "Defesa Tributária",
              ].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm">
                  <i className="ri-check-line text-amber-400"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-6">Contato</h3>
            <div className="space-y-4 text-gray-400 mb-6">
              <div className="flex items-center gap-3 text-sm">
                <i className="ri-whatsapp-line text-green-400"></i>
                <span>(12) 99721-3362</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <i className="ri-mail-line text-amber-400"></i>
                <span>dr.araujo.gabriel@gmail.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <i className="ri-instagram-line text-pink-400"></i>
                <span>@dr.araujogabriel</span>
              </div>
            </div>
            <button
              onClick={handleWhatsAppClick}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-medium text-sm transition-colors duration-200 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              Falar no WhatsApp
            </button>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-xs">
              © 2025 G | A – Advocacia Personalizada. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-gray-700 text-xs">|</span>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-300 text-xs transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
